<div class="student-story-detail">
  @if (this.dataLoaded) {
    <div class="stories-content">
      @for (category of this.categoriesWithStory; track category.id) {
        <div class="category">
          <div class="category-heading">
            <div class="icon">
              <img src="{{ category.icon }}" alt="" />
            </div>
            <h3 class="category-name">
              {{ category.name }}
            </h3>
          </div>
          <div class="sub-categories">
            @for (subCategory of category.sub_categories; track subCategory) {
              <div class="sub-category">
                <div class="sub-category-detail">
                  <div class="sub-category-content">
                    <div class="sub-category-name">
                      {{ subCategory.name }}
                    </div>
                    <div class="story-time">
                      <p>作成日時： {{ !!subCategory.story ? subCategory.story.created_at : '-' }}</p>
                      <p>更新日時： {{ !!subCategory.story ? this.getUpdatedAt(subCategory.story) : '-' }}</p>
                    </div>
                  </div>
                  @if (!subCategory.story) {
                    <a
                      class="spen-util-link story-icon"
                      (click)="sendEvent('作成する', subCategory.name)"
                      [routerLink]="['/stories/student/new']"
                      [queryParams]="{ grade: this.grade, story_category_id: subCategory.id }"
                    >
                      {{ layoutService.isTabletDownView.value ? '作成' : '作成する' }}
                    </a>
                  } @else {
                    <span class="story-icon">
                      <i
                        [ngClass]="isShowStory[subCategory.story.id] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
                        (click)="onChangeShowStory(subCategory.story.id)"
                      ></i>
                    </span>
                  }
                </div>
                @if (subCategory.story && isShowStory[subCategory.story.id]) {
                  <div class="story-detail">
                    @if (subCategory.story.vision) {
                      <div [class.story-vision]="subCategory.story.archive || subCategory.story.upload_files.length">
                        <p class="story-title">目標</p>
                        <div class="preserve-line-break break-word story-content">{{ subCategory.story.vision }}</div>
                      </div>
                    }
                    @if (subCategory.story.archive || subCategory.story.upload_files.length) {
                      <p class="story-title">やったこと・考えたこと</p>
                      @if (subCategory.story.archive) {
                        <div class="preserve-line-break break-word story-content">
                          {{ subCategory.story.archive }}
                        </div>
                      }
                      @if (subCategory.story.upload_files) {
                        <div class="story-file-views">
                          <app-story-files-view [files]="subCategory.story.upload_files"></app-story-files-view>
                        </div>
                      }
                    }
                    <a
                      class="spen-util-link story-icon"
                      [routerLink]="['/stories/student/', subCategory.story.id, 'edit']"
                      [queryParams]="{ grade: this.grade }"
                      (click)="sendEvent('編集する', subCategory.name)"
                    >
                      {{ layoutService.isTabletDownView.value ? '編集' : '編集する' }}
                    </a>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      <h2 class="teacher-comment" id="story-comment">先生からのひとこと</h2>
      <app-story-comment-list-student [grade]="this.grade"></app-story-comment-list-student>
    </div>
  } @else {
    <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
  }
</div>
